module.exports = __webpack_public_path__ + "img/2026big7.55f0295c.png";